import { useMutation } from '@apollo/client/react';
import { UPDATE_PROFILE, VENDOR_PROFILE } from 'api/graphql/user';

/**
 * Updates the shop (vendor) profile via `updateProfile({ vendorProfile })` and
 * refreshes the cached VENDOR_PROFILE so the rest of the app reflects changes.
 */
export function useUpdateVendorProfile() {
  const [mutate, { loading }] = useMutation(UPDATE_PROFILE, {
    refetchQueries: [{ query: VENDOR_PROFILE }],
    awaitRefetchQueries: true,
  });

  const updateShop = async (vendorProfileInput) => {
    const { data } = await mutate({
      variables: { input: { vendorProfile: vendorProfileInput } },
    });
    return data?.updateProfile ?? null;
  };

  return { updateShop, loading };
}
